import { useEffect, useMemo } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { NotificationManager } from '@atlas/core';

import { urlSeparator } from 'common/constants';

import { isPartialVerification, isPaymentAllowed } from '../../utils';

export const useDepositNavigation = ({
  account,
  bankAccounts,
  paymentMethod,
  preselectedPaymentMethod,
}) => {
  const { push, replace } = useHistory();
  const { url } = useRouteMatch();

  const backUrlArray = useMemo(() => {
    const endIndex = preselectedPaymentMethod ? 2 : 4;
    return url.split(urlSeparator).slice(0, endIndex);
  }, [preselectedPaymentMethod, url]);

  const backUrl = backUrlArray.join(urlSeparator);

  useEffect(() => {
    if (
      isPartialVerification(account, 'deposit') ||
      !isPaymentAllowed(account, bankAccounts, 'deposit', paymentMethod?.autofillProhibited)
    ) {
      replace(backUrl);
      NotificationManager.display({
        data: { isPartialRegulation: isPartialVerification(account, 'deposit') },
        message: 'verificationPopup',
        type: 'verificationPopup',
      });
    }
  }, [account, backUrl, bankAccounts, paymentMethod?.autofillProhibited, replace]);

  return { backUrl, push };
};
